var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contentBigBox mart10 notdata"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/dark/doctorIcon/dataLoss.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("暂无相关数据")])])])
}]

export { render, staticRenderFns }